import axios from "axios";
import { Dispatch, AnyAction } from "redux";
import AuthApi from "../api/authApi";
import { handleActionError } from "src/common/actions/actionErrorHandler";
import * as jwt_decode from "jwt-decode";
import { Token, tokenKey, LoginUser } from "../types/authentication";
import { handleAuthentication } from "../utilities/authHelper";
import { internalActionKeys } from "./internalActionKeys";
import * as Cookies from "js-cookie";

export const authenticateSuccess = (user: LoginUser): AnyAction => {
  return {
    type: internalActionKeys.AUTHENTICATE_SUCCESS,
    user
  };
};

export const internalLogout = (): AnyAction => {
  return {
    type: internalActionKeys.LOGOUT
  };
};

export const internalAuthenticate = (email: string, password: string) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await AuthApi.authenticate(email, password);
      if (response) {
        const token = jwt_decode<Token>(response);
        if (localStorage.getItem("lastAdminCheckboxState") == "true") {
          const expDate = new Date(token.exp * 1000);
          Cookies.set(tokenKey, response, { expires: expDate });
        }
        sessionStorage.setItem(tokenKey, response);
        axios.defaults.headers.common.Authorization = "Bearer " + response;
        handleAuthentication(token, dispatch);
      }
    } catch (error) {
      handleActionError(error, dispatch);
    }
  };
};
